module.exports = __webpack_public_path__ + "img/HomePEC8000.81b25a9d.png";